import React from 'react';
export function CredibilitySection() {
  return <section className="bg-[#FDF8F0] py-14 md:py-20 px-5" data-id="element-9">
      <div className="max-w-2xl mx-auto" data-id="element-10">
        <div className="bg-white/70 rounded-2xl p-6 md:p-10 border border-[#D4A853]/15 text-center" data-id="element-11">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D1F0E] mb-5 leading-snug" data-id="element-12">
            Una guía creada para el momento real
          </h2>
          <p className="text-[0.95rem] md:text-lg text-[#6B5D4F] leading-relaxed" data-id="element-13">
            Protocolo SOS fue creado para mamás que necesitan saber qué hacer
            cuando su hijo entra en crisis emocional o sensorial, especialmente
            en público o en momentos de alta presión. Está diseñado en español,
            con pasos claros, prácticos y fáciles de aplicar.
          </p>
        </div>
      </div>
    </section>;
}